function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "19",
  viewBox: "0 0 20 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.013.832c.704 0 1.276.572 1.276 1.276h-.004v3.176l-2.167 1.95-.004-3.404a.827.827 0 00-.826-.827h-1.004l-6.897.032a.392.392 0 00-.388.345c-.026.195.1.381.29.432l4.752 1.24a2.007 2.007 0 011.503 1.944L9.537 17.51c0 .927-.917 1.581-1.798 1.276L2.021 16.8A1.878 1.878 0 01.86 15.067L.853 2.107c0-.704.571-1.276 1.276-1.276h10.884zm-.887 13.05l.003 2.55a1.08 1.08 0 002.156 0v-.578l-2.16-1.972zm-3.872-1.227c0-.93-.541-1.602-1.245-1.595-.703.006-1.262.503-1.265 1.595-.002 1.092.665 1.637 1.265 1.637.6 0 1.245-.708 1.245-1.637z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.74 13.932a.4.4 0 00.67-.294l.003-1.088c0-.193.14-.357.328-.399 2.091-.457 3.7-1.631 4-3.842.047-.354-.402-.545-.704-.354-1.155.73-2.554.786-3.23.77a.396.396 0 01-.381-.4l.002-.834a.4.4 0 00-.668-.299l-3.4 3.06a.4.4 0 00-.002.593l3.383 3.087z",
  fill: "#fff"
})));